"use client";

import styles from "@/styles/home/subscribe-banner.module.scss";
import Image from "next/image";

interface Props {
  bannerSrc: string;
}

export default function SubscribeBanner({bannerSrc}: Props) {

  const handleViewDetail = () => {
    window.location.href = '/newsletters/index'
  };

  return (
    <div className={styles["comp-subscribe-banner"]}>
      {
        bannerSrc ? (
          <Image
            className={styles["subscribe-banner"]}
            src={bannerSrc}
            onClick={() => handleViewDetail()}
            alt="newsletters"
            width={"375"}
            height={"122"}
          />
        ) : null
      }
    </div>
  );
}
